import { input, query } from "@/composables/store";
import type { UccPayloadMode } from "@/utils/uccPayloadSummary";

export type UccSearchHistoryEntry = {
	id: string;
	mode: UccPayloadMode;
	payload: Record<string, unknown>;
	useCount: number;
	searchedAt: string;
};

export const UCC_HISTORY_APPLY_STATE_KEY = "ucc-history-apply-request";

export type UccHistoryApplyRequest = {
	sequence: number;
	mode: UccPayloadMode;
	payload: Record<string, unknown>;
	requestedAt: number;
};

type UccSearchHistoryRecord = {
	record_id: string;
	search_type: UccPayloadMode;
	payload: Record<string, unknown> | null;
	use_count?: number | null;
	searched_date: string;
};

function toUccSearchHistoryEntry(record: UccSearchHistoryRecord): UccSearchHistoryEntry {
	return {
		id: record.record_id,
		mode: record.search_type === "secured_party" ? "secured_party" : "debtor",
		payload: record.payload && typeof record.payload === "object" ? record.payload : {},
		useCount: Number(record.use_count ?? 1) || 1,
		searchedAt: record.searched_date,
	};
}

export async function fetchUccSearchHistory(limit: number = 8): Promise<UccSearchHistoryEntry[]> {
	const { list } = await query<UccSearchHistoryRecord>("ucc/search-history", undefined, { limit });
	return (list || []).map(toUccSearchHistoryEntry);
}

export async function deleteUccSearchHistoryEntry(id: string): Promise<void> {
	await input(`ucc/search-history/${encodeURIComponent(id)}`, {}, {}, "DELETE");
}

export async function clearUccSearchHistory(): Promise<void> {
	await input("ucc/search-history", {}, {}, "DELETE");
}
